import { Icon, Text } from '@user-portal/wikr-components';
import React from 'react';

import * as S from './Header.styled';

interface HeaderProps {
    mealType?: string;
}

export const Header = ({ mealType }: HeaderProps) => {
    return (
        <S.Header>
            <S.Link to="/meals" data-locator="meal-page-back-link" data-testid="meal-page-back-link">
                <Icon name="arrowLeft" />
            </S.Link>
            <Text type="h3">{mealType}</Text>
        </S.Header>
    );
};
